export const message_zhCN = {
  'message.templet.n01.lbl01': `模板名称`,
  'message.templet.n01.rdo02': `类型`,
  'message.templet.n01.rdo03': `审核状态`,
  'message.templet.n02.btn01': `新增模板`,
  'message.templet.c01.lbl01': `模板名称`,
  'message.templet.c01.lbl02': `类型`,
  'message.templet.c01.lbl03': `审核状态`,
  'message.templet.c01.lbl04': `内容`,
  'message.templet.c01.lbl05': `最后更新时间`,
  'message.templet.c01.lbl06': `操作人`,
  'message.templet.c01.lbl07': `操作`,
  'message.templet.d01.txt01': '确定删除此条 短信模板吗？',
  'message.templet.add.n01.lbl01': `模板名称`,
  'message.templet.add.n01.rdo02': `模板类型`,
  'message.templet.add.n01.rdo03': `签名`,
  'message.templet.add.n01.lbl04': `短信内容`,
  'message.templet.add.n01.lbl05': `发件备注`,
  'message.templet.add.n01.btn06': `提交审核`,
  'message.templet.add.n01.btn07': `发送预览`,
  'message.templet.add.n01.tip01': `请输入模版名称`,
  'message.templet.add.n01.tip02': `请选择模版类型`,
  'message.templet.add.n01.tip03': `请选择签名`,
  'message.templet.add.n01.tip04': `请输入短信内容`,
  'message.templet.add.n01.tip05': `短信内容的最大长度不得大于600`,
  'message.templet.add.n01.tip06': `请输入发件备注`,
  'message.templet.add.n01.tip07': `发件备注的最大长度不得大于80`,
  'message.templet.add.c01.lbl01': `添加短信模版`,
  'message.templet.add.d01.lbl01': `手机号`,
  'message.templet.add.d01.txt02': `可输入手机号码，手机号用逗号隔开，最多输入20个手机号`,
  'message.templet.add.n01.tip08': `请输入手机号`,
};

export const message_enUS = {
  'message.templet.n01.lbl01': `TEMPLET NAME`,
  'message.templet.n01.rdo02': `TYPE`,
  'message.templet.n01.rdo03': `VERIFY STATUS`,
  'message.templet.n02.btn01': `ADD TEMPLET`,
  'message.templet.c01.lbl01': `TEMPLET NAME`,
  'message.templet.c01.lbl02': `TYPE`,
  'message.templet.c01.lbl03': `VERIFY STATUS`,
  'message.templet.c01.lbl04': `CONTENTS`,
  'message.templet.c01.lbl05': `LASTEST UPDATE TIME`,
  'message.templet.c01.lbl06': `OPERATOR`,
  'message.templet.c01.lbl07': `ACTION`,
  'message.templet.d01.txt01': '确定删除此条 短信模板吗？',
  'message.templet.add.n01.lbl01': `TEMPLET NAME`,
  'message.templet.add.n01.rdo02': `TEMPLET TYPE`,
  'message.templet.add.n01.rdo03': `SIGN`,
  'message.templet.add.n01.lbl04': `CONTENTS`,
  'message.templet.add.n01.lbl05': `REMARK`,
  'message.templet.add.n01.btn06': `VERIFY`,
  'message.templet.add.n01.btn07': `VIEW`,
  'message.templet.add.n01.tip01': ``, //请输入模版名称
  'message.templet.add.n01.tip02': ``, //请选择模版类型
  'message.templet.add.n01.tip03': ``, //请选择签名
  'message.templet.add.n01.tip04': ``, //请输入短信内容
  'message.templet.add.n01.tip05': ``, //短信内容的最大长度不得大于80
  'message.templet.add.n01.tip06': ``, //请输入发件备注
  'message.templet.add.n01.tip07': ``, //发件备注的最大长度不得大于80
  'message.templet.add.c01.lbl01': ``, //添加短信模版
  'message.templet.add.d01.lbl01': `MP NUMBER`, //手机号
  'message.templet.add.d01.txt02': `ENTER MP NUMBER DIVIDED BY COMMA,UP TO 20.`, //可输入手机号码，手机号用逗号隔开，最多输入20个手机号
  'message.templet.add.n01.tip08': ``, //请输入手机号
};
